import posthog from 'posthog-js'

import { getInfoAboutService, initializeUsercentricsListeners } from 'utils/getInfoAboutService'

const POSTHOG_API_KEY = 'phc_kPJRVjTcrUWfKTExXaG3PTkpamFiUSXZsJZiHEv9uQZJ'
const POSTHOG_API_HOST = 'https://us.i.posthog.com'
const USERCENTRICS_POSTHOG_NAME = 'PostHog.com'

/**
 * Dev environment's hostname — not a developer's local machine, see isLocal() for that.
 */
const isDevEnvironment = () => window.location.hostname === 'app.manychat.io'

let isInitialized = false

const isConsentGiven = () =>
  getInfoAboutService(USERCENTRICS_POSTHOG_NAME)[USERCENTRICS_POSTHOG_NAME]?.status ?? false

const loadPostHog = () => {
  if (isInitialized || !isConsentGiven()) {
    return
  }

  isInitialized = true

  // Canvas/WebGL recording is a per-project PostHog dashboard setting, not a client init option.
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_API_HOST,
    defaults: '2026-05-30',
    person_profiles: 'identified_only',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: false,
  })
}

export const initPostHog = () => {
  if (!isDevEnvironment()) {
    return
  }

  loadPostHog()
  initializeUsercentricsListeners(loadPostHog)
}

/**
 * Whether session replay is actively recording. Consumers that need the WebGL drawing buffer kept
 * readable for canvas capture (see PixiStage) should gate on this rather than preserve it always.
 */
export const isSessionRecordingActive = () => isInitialized && posthog.sessionRecordingStarted()
